/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 17th 2022, 7:54:29 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { APISERVICEPATHS, useAPIForm, UseAPIFormSpec } from "lib/api";
import { NotificationTemplate, NotificationTemplateValidationSchema } from "lib/schemas";
import { useDeleteOSItem } from "version-control/services/DeleteOSItemAPI";

/** NotificationTemplates API */

const notificationTemplatesAPI = APISERVICEPATHS.notificationTemplates;

export interface UseNotificationTemplateAPIFormSpec {
  notificationTemplateFetchId: UseAPIFormSpec<NotificationTemplate>["apiInitialFetchId"];
  notificationTemplateDefaultValues: NotificationTemplate;
  updateNotificationTemplateFromAPICallback: UseAPIFormSpec<NotificationTemplate>["setAPIFormResponse"];
  onSuccessfulAPISave: () => void;
}

export const useNotificationTemplateAPIForm = ({
  notificationTemplateFetchId,
  notificationTemplateDefaultValues,
  updateNotificationTemplateFromAPICallback,
  onSuccessfulAPISave,
}: UseNotificationTemplateAPIFormSpec) => {
  const useAPIFormReturn = useAPIForm({
    apiServicePath: notificationTemplatesAPI,
    apiFormDataValidationSchema: NotificationTemplateValidationSchema,
    apiFormDefaultValues: notificationTemplateDefaultValues,
    apiInitialFetchId: notificationTemplateFetchId,
    primaryKey: "id",
    setAPIFormResponse: updateNotificationTemplateFromAPICallback,
  });

  React.useEffect(() => {
    if (useAPIFormReturn.isSuccessfulAPIDataSend) onSuccessfulAPISave?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useAPIFormReturn.isSuccessfulAPIDataSend]);

  return useAPIFormReturn;
};

export const useDeleteNotificationTemplate = () => useDeleteOSItem(notificationTemplatesAPI);
